import { render } from "./TransactionItems.vue?vue&type=template&id=52a04efc"
import script from "./TransactionItems.vue?vue&type=script&lang=js"
export * from "./TransactionItems.vue?vue&type=script&lang=js"

import "./TransactionItems.vue?vue&type=style&index=0&id=52a04efc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__